import React from 'react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText } from '../../components';

function ProgramLevels({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const items = data.items || [];
  const updateItem = (i, patch) => {
    const next = items.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    update({ items: next });
  };
  return (
    <section className="py-24 bg-olive-light">
      <div className="container-page">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="eyebrow justify-center"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
          </h2>
          <p className="section-lead mx-auto">
            <EditableText value={data.lead} onChange={(t) => update({ lead: t })} as="span" multiline />
          </p>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {items.map((p, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="card-surface p-8 h-full">
                <div className="font-display text-5xl text-accent/70">0{i + 1}</div>
                <EditableText value={p.title} onChange={(t) => updateItem(i, { title: t })} as="h3" className="font-display text-2xl mt-4" />
                <EditableText value={p.desc} onChange={(t) => updateItem(i, { desc: t })} as="p" multiline className="mt-3 text-ink/70 leading-relaxed" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProgramLevels;
